<template>
	<div class="c-list-renderer">
		<ReadingView
			v-if="currentView === 'reading'"
			:computedNotes="computedNotes"
		></ReadingView>
		<GridView
			v-if="currentView === 'grid'"
			:computedNotes="computedNotes"
		></GridView>
		<EmptyState v-if="computedNotes.length < 1 && init"></EmptyState>
	</div>
</template>

<script>
import _ from 'lodash';
import Fuse from 'fuse.js';
import moment from 'moment';
import readingItem from '@/components/dashboard/reading-item.vue';
import readingHeader from '@/components/dashboard/reading-header.vue';
import EmptyState from '@/components/dashboard/empty-state';

import GridView from '@/components/dashboard/grid-view';

import ReadingView from '@/components/dashboard/reading-view';

export default {
	components: {
		readingItem,
		readingHeader,
		EmptyState,
		ReadingView,
		GridView,
	},
	data: function () {
		return {
			//groupStrategy: 'domains', // can be buckets
		};
	},
	props: ['query'],
	watch: {
		computedNotes: function (notes) {
			let temp = notes.filter((note) => {
				if (note.type === 'note') {
					return true;
				} else {
					return false;
				}
			});
			this.$store.dispatch('dashboard/updateNotecount', temp.length);
		},
		trimmedNotes: function (notes) {
			this.$store.dispatch('dashboard/updateTotal', notes.length);
		},
	},
	computed: {
		init: function () {
			return this.$store.getters['init'];
		},
		currentView: function () {
			return this.$store.getters['dashboard/listView'];
		},
		notes: function () {
			return this.$store.getters['note/notes'];
		},
		buckets: function () {
			return this.$store.getters['bucket/buckets'];
		},
		trimmedNotes: function () {
			let notes = this.notes;
			if (this.currentFolder) {
				notes = this.filterByFolder(notes, this.currentFolder._id);
			}
			return notes;
		},
		computedNotes: function () {
			let notes = this.trimmedNotes;
			if (this.search && this.search.length > 0) {
				notes = this.searchByText(notes, this.search);
			}
			if (this.dateFilter) {
				notes = this.filterByDate(notes, this.dateFilter);
			}
			if (!this.currentFolder && this.groupStrategy === 'domains') {
				notes = this.groupByDomain(notes);
			} else if (!this.currentFolder && this.groupStrategy === 'buckets') {
				notes = this.groupByBucket(notes);
			} else if (!this.currentFolder && this.groupStrategy === 'pages') {
				notes = this.groupByPages(notes);
			} else if (!this.currentFolder && this.groupStrategy === 'type') {
				notes = this.groupByType(notes);
			} else {
				notes = this.groupDefault(notes);
			}
			return notes;
		},
		search: function () {
			return this.$store.getters['dashboard/search'];
		},
		dateFilter: function () {
			return this.$store.getters['dashboard/dateFilter'];
		},
		currentFolder: function () {
			return this.$store.getters['dashboard/currentFolder'];
		},
		groupStrategy: function () {
			return this.$store.getters['dashboard/groupStrategy'];
		},
	},
	methods: {
		filterByFolder: function (notes, folderId) {
			notes = notes.filter((note) => {
				if (note.folder === folderId) {
					return true;
				} else {
					return false;
				}
			});
			return notes;
		},
		filterByDate: function (notes, dateFilter) {
			let newNotes = [];
			let isBetween = false;
			let startDate = moment(dateFilter.start);
			let endDate = moment(dateFilter.end);
			if (moment(startDate).isSame(endDate)) {
				endDate.add(1, 'days');
			}
			for (var i = 0; i < notes.length; i++) {
				isBetween = moment
					.utc(notes[i].createdAt)
					.isBetween(startDate, endDate);

				if (isBetween) {
					newNotes.push(notes[i]);
				}
			}
			notes = newNotes;
			return newNotes;
		},
		searchByText: function (notes, text) {
			let options = {
				includeScore: false,
				shouldSort: true,
				threshold: 0.3,
				location: 0,
				distance: 100,
				ignoreLocation: true,
				maxPatternLength: 32,
				minMatchCharLength: 1,
				keys: [
					{
						name: 'text',
						weight: 0.75,
					},
					{
						name: 'domain',
						weight: 1.25,
					},
					{
						name: 'comment.raw',
						weight: 1,
					},
				],
			};
			let fuse = new Fuse(notes, options);
			let extendedNotes = fuse.search(text);
			let arr = [];
			for (let i = 0; i < extendedNotes.length; i++) {
				arr.push(extendedNotes[i].item);
			}
			return arr;
		},
		groupDefault: function (notes) {
			notes = notes.map((note) => {
				return {
					type: 'note',
					item: note,
				};
			});
			return notes;
		},
		groupByDomain: function (notes) {
			let newNotes = [];
			let grouped = _.groupBy(notes, 'domain');
			grouped = this.sortObject(grouped);
			let temp = [];
			let listSortEnabled = true;
			for (let property in grouped) {
				if (grouped.hasOwnProperty(property)) {
					newNotes.push({
						type: 'header',
						title: grouped[property][0].domain,
						composition: this.getComposition(grouped[property]),
						site: {
							count: grouped[property].length,
						},
						domain: property,
						avatarUrl: 'https://' + grouped[property][0].domain,
						headerKey: grouped[property][0].domain,
					});
					let pages = _.groupBy(grouped[property].sort(this.sortNote), 'ref');
					if (Object.keys(pages).length > 1) {
						for (let property2 in pages) {
							if (pages.hasOwnProperty(property2)) {
								newNotes.push({
									type: 'divider',
									domain: property,
									count: pages[property2].length,
									index: property2,
									title: pages[property2][0].ref,
									headerKey: pages[property2][0].domain,
								});
								let temp = [];
								for (var i = 0; i < pages[property2].length; i++) {
									temp.push({
										type: 'note',
										item: pages[property2][i],
										headerKey: pages[property2][i].domain,
									});
								}
								temp = temp.sort(this.sortSubList);
								for (var i = 0; i < temp.length; i++) {
									newNotes.push(temp[i]);
								}
							}
						}
					} else {
						for (let property2 in pages) {
							if (pages.hasOwnProperty(property2)) {
								let temp = [];
								for (var i = 0; i < pages[property2].length; i++) {
									temp.push({
										type: 'note',
										item: pages[property2][i],
										headerKey: pages[property2][i].domain,
									});
								}
								temp = temp.sort(this.sortSubList);
								for (var i = 0; i < temp.length; i++) {
									newNotes.push(temp[i]);
								}
							}
						}
					}
				}
			}

			return newNotes;
		},
		groupByPages: function (notes) {
			let newNotes = [];
			let grouped = _.groupBy(notes, 'ref');
			grouped = this.sortObject(grouped);
			let temp = [];
			let listSortEnabled = true;
			for (let property in grouped) {
				if (grouped.hasOwnProperty(property)) {
					newNotes.push({
						type: 'header',
						title: this.prettifyDomain(grouped[property][0].ref),
						composition: this.getComposition(grouped[property]),
						site: {
							count: grouped[property].length,
						},
						domain: property,
						avatarUrl: 'https://' + grouped[property][0].domain,
						headerKey: grouped[property][0].ref,
					});
					let pages = _.groupBy(grouped[property].sort(this.sortNote), 'ref');
					for (let property2 in pages) {
						if (pages.hasOwnProperty(property2)) {
							let temp = [];
							for (var i = 0; i < pages[property2].length; i++) {
								temp.push({
									type: 'note',
									item: pages[property2][i],
									headerKey: pages[property2][i].ref,
								});
							}
							temp = temp.sort(this.sortSubList);
							for (var i = 0; i < temp.length; i++) {
								newNotes.push(temp[i]);
							}
						}
					}
				}
			}

			return newNotes;
		},
		prettifyDomain: function (link) {
			let url = new URL(link);
			if (url.pathname !== '/') {
				return url.host + url.pathname;
			} else {
				return url.host;
			}
		},
		/**
		 * This works, just need a bit of cleanup
		 */
		groupByBucket: function (notes) {
			let newNotes = [];
			let grouped = _.groupBy(notes, 'bucket');
			grouped = this.sortObject(grouped);
			let temp = [];
			let listSortEnabled = true;
			for (let property in grouped) {
				if (grouped.hasOwnProperty(property)) {
					let title = grouped[property][0].bucket;
					if (!title) {
						title = 'No buckets';
					}
					let color = 1;
					let bucket = false;
					if (grouped[property][0].bucket) {
						bucket = this.buckets.filter((bucket) => {
							if (grouped[property][0].bucket === bucket._id) {
								return true;
							}
							return false;
						});
						if (bucket.length > 0) {
							bucket = bucket[0];
						}
					}
					if (bucket) {
						color = bucket.color;
						title = bucket.title;
					}
					newNotes.push({
						type: 'header',
						title: title,
						composition: this.getComposition(grouped[property]),
						site: {
							count: grouped[property].length,
						},
						domain: property,
						color: color,
						headerKey: grouped[property][0].bucket,
					});
					let pages = _.groupBy(grouped[property].sort(this.sortNote), 'ref');
					for (let property2 in pages) {
						if (pages.hasOwnProperty(property2)) {
							let temp = [];
							for (var i = 0; i < pages[property2].length; i++) {
								temp.push({
									type: 'note',
									item: pages[property2][i],
									headerKey: pages[property2][i].bucket,
								});
							}
							temp = temp.sort(this.sortSubList);
							for (var i = 0; i < temp.length; i++) {
								newNotes.push(temp[i]);
							}
						}
					}
				}
			}

			return newNotes;
		},
		groupByType: function (notes) {
			let newNotes = [];
			let grouped = _.groupBy(notes, 'type');
			console.log(grouped);
			grouped = this.sortObject(grouped);
			let temp = [];
			let listSortEnabled = true;
			for (let property in grouped) {
				if (grouped.hasOwnProperty(property)) {
					let title = grouped[property][0].type;
					newNotes.push({
						type: 'header',
						title: title,
						composition: this.getComposition(grouped[property]),
						site: {
							count: grouped[property].length,
						},
						domain: property,
						avatarUrl: 'https://' + grouped[property][0].ref,
						headerKey: grouped[property][0].type,
					});
					let pages = _.groupBy(grouped[property].sort(this.sortNote), 'ref');
					for (let property2 in pages) {
						if (pages.hasOwnProperty(property2)) {
							newNotes.push({
								type: 'divider',
								domain: property,
								count: pages[property2].length,
								index: property2,
								headerKey: pages[property2][0].type,
							});
							let temp = [];
							for (var i = 0; i < pages[property2].length; i++) {
								temp.push({
									type: 'note',
									item: pages[property2][i],
									headerKey: pages[property2][i].type,
								});
							}
							temp = temp.sort(this.sortSubList);
							for (var i = 0; i < temp.length; i++) {
								newNotes.push(temp[i]);
							}
						}
					}
				}
			}

			return newNotes;
		},
		sortObject: function (obj) {
			var sortable = [];
			for (var item in obj) {
				sortable.push([item, obj[item]]);
			}
			for (var i = 0; i < sortable.length; i++) {
				let latestDate = this.getLatestDate(sortable[i][1]);
				sortable[i][2] = latestDate;
			}

			sortable = sortable.sort(this.sortList);
			let newObj = {};
			for (var i = 0; i < sortable.length; i++) {
				newObj[sortable[i][0]] = sortable[i][1];
			}

			return newObj;
		},
		sortList: function (a, b) {
			let aDate = a[2];
			let bDate = b[2];
			let diff = moment(aDate).diff(moment(bDate));
			diff = diff * -1;
			return diff;
		},
		getComposition: function (arr) {
			let obj = {
				text: 0,
				code: 0,
				bookmark: 0,
				video: 0,
				ids: [],
			};
			for (let i = 0; i < arr.length; i++) {
				obj.ids.push(arr[i].id);
				obj[arr[i].type] += 1;
			}
			return obj;
		},
		getLatestDate: function (array) {
			if (!array) {
				return;
			}
			let max = new Date(
				Math.max.apply(
					null,
					array.map(function (e) {
						return new Date(e.createdAt);
					})
				)
			);
			return max;
		},
		sortSubList: function (a, b) {
			let Aposition = 0;
			let Bposition = 0;
			let meta = a.item.meta || {};
			let position = meta.position || 0;
			Aposition = position;
			meta = b.item.meta || {};
			position = meta.position || 0;
			Bposition = position;
			return Aposition - Bposition;
		},
	},
};
</script>

<style lang="scss">
.c-list-renderer {
	position: relative;
	width: 100%;
	min-height: 100%;
	height: auto;

	&__reading {
		max-width: 760px;
		padding: 0 $lg-margins;
		margin: 0 auto;
	}

	&__grid {
		width: 100%;
		height: 100%;
	}
}
</style>